export default "__VITE_ASSET__CZIeU7Ft__"